var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_c('label',[_vm._v("ハッシュタグ")]),_c('ul',{staticClass:"inverse tagIt"},_vm._l(((_vm.tag_string.split(' '))),function(tag){return _c('li',{key:tag},[_c('a',[_vm._v(_vm._s(tag))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }